export default __webpack_public_path__ + "static/media/upload-photo.c9b8bae0.png";